import { Injectable } from "@angular/core";
import { UNIT_SYSTEM } from "@zonar-ui/i18n";
import { currentLocale, unitSystem } from "src/app/i18next";

// the purpose of this service is soley to facilitate testability with respect to locale
@Injectable({
	providedIn: "root",
})
export class LocaleService {
	/**
	 * The locale used to pick translations and date formats. Collapsed onto the six locales we
	 * ship translation files for, so 'en-CA' resolves to 'en-us' here. Do not use it to decide
	 * units: that collapse discards the region subtag which distinguishes 'en-US' from 'en-CA'.
	 */
	getCurrentLocale() {
		return currentLocale();
	}

	usesMetricSystem(): boolean {
		return unitSystem() === UNIT_SYSTEM.METRIC;
	}
}
